import React, { memo, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import cls from './WeatherBlock.module.css';
import { useWeatherBlock } from './useWeatherBlock';
import { Days } from '../../types/dashboardInformation';
import { EmptyWeatherBlock } from './EmptyWeatherBlock';

interface WeatherBlockProps {
    classes?: string;
}

const useResizeObserver = (ref) => {
    const [size, setSize] = useState({ width: 0, height: 0 });

    useEffect(() => {
        const handleResize = (entries) => {
            for (let entry of entries) {
                setSize({
                    width: entry.contentRect.width,
                    height: entry.contentRect.height,
                });
            }
        };

        const observer = new ResizeObserver(handleResize);
        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            if (ref.current) {
                observer.unobserve(ref.current);
            }
        };
    }, [ref]);

    return size;
};

export const WeatherBlock = memo(({ classes }: WeatherBlockProps) => {
    const { onShowModal, weather, can_show_financial_info, is_customer } = useWeatherBlock();

    const weatherBlockRef = useRef(null);
    const { height } = useResizeObserver(weatherBlockRef);

    if (!weather)
        return (
            <EmptyWeatherBlock
                can_show_financial_info={can_show_financial_info}
                is_customer={is_customer}
            />
        );

    return (
        <div
            ref={weatherBlockRef}
            className={classNames(cls.WeatherBlock, [classes], {
                // [cls.notFinance]: !can_show_financial_info || is_customer,
                [cls.gap]: height > 186,
            })}
        >
            <div className={cls.weatherRow}>
                <div className={cls.todayWeather}>
                    <div className={cls.todayWeatherDateContent}>
                        <div className={cls.todayWeatherDateContentTitle}>
                            {i18next.t('WeatherBlock.return.todayWeatherDateContentTitle')}
                        </div>
                        <div className={cls.todayWeatherDateContentDate}>
                            ({weather.current_date})
                        </div>
                    </div>
                    <div className={cls.todayWeatherValue}>
                        <div className={cls.mapPreviewValue}>{weather.current_temperature}°</div>
                        <div className={cls.mapPreviewIcon}>
                            <img
                                alt={'current_icon_image_url'}
                                src={weather.current_icon_image_url}
                            />
                        </div>
                    </div>
                </div>
                {can_show_financial_info && (
                    <div
                        className={classNames(cls.mapPreview, {
                            [cls.hidden]: height > 186,
                        })}
                        onClick={onShowModal}
                    >
                        <img src={weather.map_url} alt={'mapPreview'} />
                    </div>
                )}
            </div>
            <div className={cls.weekWeather}>
                {weather.days.map((day: Days) => (
                    <div className={cls.weekWeatherItem}>
                        <div className={cls.weekWeatherDate}>{day.date}</div>
                        <div className={cls.weekWeatherIcon}>
                            <img alt={'icon_image_url'} src={day.icon_image_url} />
                        </div>
                        <div className={cls.weekWeatherValue}>{day.temperature}°</div>
                    </div>
                ))}
            </div>

            <div
                className={classNames(cls.mapPreviewBig, {
                    [cls.visible]: height > 186,
                })}
                onClick={onShowModal}
            >
                <img src={weather.map_url} alt={'mapPreview'} />
            </div>
        </div>
    );
});
